module.exports = __webpack_public_path__ + "static/fullWidthRows-b2e3f80521cfea4e5358746795a0c600.gif";